export enum STEPS {
  SETUP_PAYROLL = 1,
  BANK_ACCOUNTS = 2,
  PAY_DISTRIBUTION = 3,
}
